<template>
  <div class="seoBoard">
    <div class="seoBoardhead">
      <div class="title">
        <div class="name">网站列表</div>
        <div class="time" v-if="false">2019.03.01_2019.02.19</div>
      </div>
      <el-button type="primary" size="small" @click="showDialog"
        >添加网站</el-button
      >
    </div>
    <!-- 网站列表 -->
    <data-list
      :data="data"
      :columns="column"
      :tableStyle="{ name: 'mixture' }"
      :page="page"
      :page-size="page.pageSize"
      :loading="loading"
      @page-size-changed="pageSizeChanged"
      @page-changed="pageChanged"
    >
    </data-list>
    <!-- 添加对话框 -->
    <dialog-form
      :dialogVisible.sync="isShowDoalog"
      :formData="formData"
      :attributes="attributes"
      @close:dialogVisible="val => (isShowDoalog = val)"
      @confirm="addWebsite"
    ></dialog-form>
  </div>
</template>

<script>
import listPageCreate from "@/mixins/listPageCreate";
import api from "@/backend/apiConfig/apiConfig";
import detailBtn from "@/components/SEO/detailBtn";
import store from "@/backend/store/index";
import seo from "@/backend/services/seo/seoBoard.js";
import formCombination from "@/components/iglobalwin/formCombination/formCombination.vue";
import { validRequired } from "@/common/elementValid";
import dialogForm from "@/components/dialogForm/dialogForm";
import beforeRouteEnter from "@/mixins/beforeRouteEnter.js";
const list = listPageCreate({
  searchConfig: {
    api: api.seo.getboardlist,
    method: "POST"
  }
});
export default {
  mixins: [list, beforeRouteEnter],
  data() {
    const that = this;
    const column = [
      {
        label: "公司名称",
        type: "custInfo",
        text: [
          {
            bind: "customerName"
          }
        ],
        minWidth: 100
      },
      {
        label: "公司网址",
        type: "custom",
        bind: "domain",
        componentName: detailBtn
      },
      {
        label: "优化关键词",
        bind: "keywordCount",
        align: "center"
      },
      {
        label: "生成文章",
        bind: "articleCount",
        align: "center"
      },
      {
        label: "操作",
        type: "btnClick",
        style: "text",
        align: "center",
        bind: [
          {
            text: "关键词规划",
            trigger: row => {
              that.$router.push({
                name: "keywordPlanning",
                query: {
                  id: row.id
                }
              });
            }
          },
          {
            text: "文章助手",
            trigger: row => {
              that.$router.push({
                name: "articleAssistant",
                query: {
                  id: row.id
                }
              });
            }
          }
        ]
      }
    ];
    return {
      column: column,
      isShowDoalog: false,
      formData: {},
      attributes: {
        title: "添加网站",
        width: "30%",
        labelWidth: "120px",
        clickModal: false,
        pressEscape: true
      }
    };
  },
  methods: {
    // 显示对话框
    showDialog() {
      this.isShowDoalog = true;
    },
    serFormData(id) {
      let formData = {
        company: {
          label: "公司：",
          labelWidth: "140px",
          formType: "customer-search",
          value: id || "",
          placeholder: "",
          options: [],
          rules: [validRequired(), "change"]
        },
        website: {
          label: "网站：",
          labelWidth: "140px",
          formType: "sky-select",
          value: "",
          props: {
            label: "name",
            value: "id"
          },
          options: []
        },
        product: {
          label: "核心产品：",
          labelWidth: "140px",
          formType: "sky-textarea",
          value: "",
          placeholder: "多个产品间使用英文逗号“,”进行分割",
          rules: [validRequired(), "change"]
        },
        keyword: {
          label: "核心关键词：",
          labelWidth: "140px",
          formType: "sky-textarea",
          value: "",
          placeholder: "多个关键词间使用英文逗号“,”进行分割",
          rules: [validRequired(), "change"]
        }
      };
      this.formData = formData;
    },
    addWebsite(callBack) {
      let { company, website, product, keyword } = this.formData;
      seo
        .addseoweb({
          coreKeyword: keyword.value,
          coreProduct: product.value,
          customerId: company.value,
          siteId: website.value
        })
        .then(res => {
          if (res.status === 201) {
            this.$message({
              message: "添加网站成功",
              type: "success",
              duration: 1500
            });
            this.query();
            callBack && callBack();
            this.isShowDoalog = false;
          } else {
            callBack && callBack();
            this.$message({
              message: "添加网站失败",
              type: "warning",
              duration: 1500
            });
          }
        })
        .catch(err => {
          this.$message({
            message: err.response.data.errorMessage,
            type: "warning",
            duration: 1500
          });
        });
    },
    cancel() {
      this.isShowDoalog = false;
    }
  },
  computed: {
    // 客户Id
    customerId() {
      return store.getters.customerId;
    }
  },
  components: { formCombination, dialogForm },
  mounted() {
    // this.query();
    this.serFormData();
  },
  watch: {
    "formData.company.value"(newValue) {
      if (!newValue) {
        return false;
      }
      this.serFormData(newValue);
      seo.getpulldownlist(newValue).then(res => {
        if (res.data == "") {
          this.$message({
            message: "未关联Google服务单，暂无数据",
            type: "warning",
            duration: 1500
          });
        }
        if (res.data) {
          this.formData.website.options = res.data;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.seoBoard {
  background-color: #f1f4f9;
  .seoBoardhead {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    padding: 18px 20px;
    margin-bottom: 10px;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      color: #666;
      .name {
        font-size: 16px;
        color: #333;
        font-weight: bold;
        margin-right: 15px;
      }
    }
  }
}
.dialogBtn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
